export const SERVICE_BLOK_FIELDS = [ "_uid", "component", "_editable" ]